import { CardContent } from "@qw/ui";
import type { FC } from "react";

export const DrafttNotFound: FC = () => (
  <CardContent>
    <div className="text-center py-4">
      <p className="text-sm text-muted-foreground">Draft not found</p>
    </div>
  </CardContent>
);
